import { render, staticRenderFns } from "./ProductoTiendaModalComponent.vue?vue&type=template&id=3829c61e&"
import script from "./ProductoTiendaModalComponent.vue?vue&type=script&lang=js&"
export * from "./ProductoTiendaModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports